import React, { useState } from 'react';

import moment from 'moment';
import * as Yup from 'yup';

import { Report } from '~/components';
import { DateTime, Autocomplete, Input, RadioGroup } from '~/components/Form';
import { t } from '~/helpers';

function Relextratoproduto() {
  const [open, setOpen] = useState(true);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  function handleSerializeForm(params) {
    return {
      ...params,
    };
  }

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        idposto: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        idproduto: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.extratoproduto')}
      relatorio="extratoproduto"
      serialize={(param) => handleSerializeForm(param)}
      validate={(param) => handleValidate(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <Autocomplete
        name="idposto"
        label="nomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        defaultValue=""
        hiddens={[{ name: 'nomeposto' }]}
      />

      <Autocomplete
        name="idproduto"
        label="nomeproduto"
        url="produtos"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        defaultValue=""
        hiddens={[{ name: 'nomeproduto' }]}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relextratoproduto;
